import _defineProperty from "/Users/vitalyrtishchev/code/mantine-master/docs/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/Users/vitalyrtishchev/code/mantine-master/docs/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { combineTransactionSteps, getChangedRanges, getMarksBetween, findChildrenInRange, getAttributes, Mark, mergeAttributes, markPasteRule } from '@tiptap/core';
import { test, find as _find, registerCustomProtocol, reset } from 'linkifyjs';
import { Plugin, PluginKey } from 'prosemirror-state';

function autolink(options) {
  return new Plugin({
    key: new PluginKey('autolink'),
    appendTransaction: function appendTransaction(transactions, oldState, newState) {
      var docChanges = transactions.some(function (transaction) {
        return transaction.docChanged;
      }) && !oldState.doc.eq(newState.doc);
      var preventAutolink = transactions.some(function (transaction) {
        return transaction.getMeta('preventAutolink');
      });

      if (!docChanges || preventAutolink) {
        return;
      }

      var tr = newState.tr;
      var transform = combineTransactionSteps(oldState.doc, _toConsumableArray(transactions));
      var mapping = transform.mapping;
      var changes = getChangedRanges(transform);
      changes.forEach(function (_ref) {
        var oldRange = _ref.oldRange,
            newRange = _ref.newRange;
        // at first we check if we have to remove links
        getMarksBetween(oldRange.from, oldRange.to, oldState.doc).filter(function (item) {
          return item.mark.type === options.type;
        }).forEach(function (oldMark) {
          var newFrom = mapping.map(oldMark.from);
          var newTo = mapping.map(oldMark.to);
          var newMarks = getMarksBetween(newFrom, newTo, newState.doc).filter(function (item) {
            return item.mark.type === options.type;
          });

          if (!newMarks.length) {
            return;
          }

          var newMark = newMarks[0];
          var oldLinkText = oldState.doc.textBetween(oldMark.from, oldMark.to, undefined, ' ');
          var newLinkText = newState.doc.textBetween(newMark.from, newMark.to, undefined, ' ');
          var wasLink = test(oldLinkText);
          var isLink = test(newLinkText); // remove only the link, if it was a link before too
          // because we don’t want to remove links that were set manually

          if (wasLink && !isLink) {
            tr.removeMark(newMark.from, newMark.to, options.type);
          }
        }); // now let’s see if we can add new links

        var nodesInChangedRanges = findChildrenInRange(newState.doc, newRange, function (node) {
          return node.isTextblock;
        });
        var textBlock;
        var textBeforeWhitespace;

        if (nodesInChangedRanges.length > 1) {
          // Grab the first node within the changed ranges (ex. the first of two paragraphs when hitting enter)
          textBlock = nodesInChangedRanges[0];
          textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, undefined, ' ');
        } else if (nodesInChangedRanges.length // We want to make sure to include the block seperator argument to treat hard breaks like spaces
        && newState.doc.textBetween(newRange.from, newRange.to, ' ', ' ').endsWith(' ')) {
          textBlock = nodesInChangedRanges[0];
          textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, newRange.to, undefined, ' ');
        }

        if (textBlock && textBeforeWhitespace) {
          var wordsBeforeWhitespace = textBeforeWhitespace.split(' ').filter(function (s) {
            return s !== '';
          });

          if (wordsBeforeWhitespace.length <= 0) {
            return false;
          }

          var lastWordBeforeSpace = wordsBeforeWhitespace[wordsBeforeWhitespace.length - 1];
          var lastWordAndBlockOffset = textBlock.pos + textBeforeWhitespace.lastIndexOf(lastWordBeforeSpace);

          if (!lastWordBeforeSpace) {
            return false;
          }

          _find(lastWordBeforeSpace).filter(function (link) {
            return link.isLink;
          }).filter(function (link) {
            if (options.validate) {
              return options.validate(link.value);
            }

            return true;
          }) // calculate link position
          .map(function (link) {
            return _objectSpread(_objectSpread({}, link), {}, {
              from: lastWordAndBlockOffset + link.start + 1,
              to: lastWordAndBlockOffset + link.end + 1
            });
          }) // add link mark
          .forEach(function (link) {
            tr.addMark(link.from, link.to, options.type.create({
              href: link.href
            }));
          });
        }
      });

      if (!tr.steps.length) {
        return;
      }

      return tr;
    }
  });
}

function clickHandler(options) {
  return new Plugin({
    key: new PluginKey('handleClickLink'),
    props: {
      handleClick: function handleClick(view, pos, event) {
        var _a;

        var attrs = getAttributes(view.state, options.type.name);
        var link = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('a');

        if (link && attrs.href) {
          window.open(attrs.href, attrs.target);
          return true;
        }

        return false;
      }
    }
  });
}

function pasteHandler(options) {
  return new Plugin({
    key: new PluginKey('handlePasteLink'),
    props: {
      handlePaste: function handlePaste(view, event, slice) {
        var state = view.state;
        var selection = state.selection;
        var empty = selection.empty;

        if (empty) {
          return false;
        }

        var textContent = '';
        slice.content.forEach(function (node) {
          textContent += node.textContent;
        });

        var link = _find(textContent).find(function (item) {
          return item.isLink && item.value === textContent;
        });

        if (!textContent || !link) {
          return false;
        }

        options.editor.commands.setMark(options.type, {
          href: link.href
        });
        return true;
      }
    }
  });
}

var Link = Mark.create({
  name: 'link',
  priority: 1000,
  keepOnSplit: false,
  onCreate: function onCreate() {
    this.options.protocols.forEach(registerCustomProtocol);
  },
  onDestroy: function onDestroy() {
    reset();
  },
  inclusive: function inclusive() {
    return this.options.autolink;
  },
  addOptions: function addOptions() {
    return {
      openOnClick: true,
      linkOnPaste: true,
      autolink: true,
      protocols: [],
      HTMLAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow',
        class: null
      },
      validate: undefined
    };
  },
  addAttributes: function addAttributes() {
    return {
      href: {
        default: null
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'a[href]:not([href *= "javascript:" i])'
    }];
  },
  renderHTML: function renderHTML(_ref2) {
    var HTMLAttributes = _ref2.HTMLAttributes;
    return ['a', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setLink: function setLink(attributes) {
        return function (_ref3) {
          var chain = _ref3.chain;
          return chain().setMark(_this.name, attributes).setMeta('preventAutolink', true).run();
        };
      },
      toggleLink: function toggleLink(attributes) {
        return function (_ref4) {
          var chain = _ref4.chain;
          return chain().toggleMark(_this.name, attributes, {
            extendEmptyMarkRange: true
          }).setMeta('preventAutolink', true).run();
        };
      },
      unsetLink: function unsetLink() {
        return function (_ref5) {
          var chain = _ref5.chain;
          return chain().unsetMark(_this.name, {
            extendEmptyMarkRange: true
          }).setMeta('preventAutolink', true).run();
        };
      }
    };
  },
  addPasteRules: function addPasteRules() {
    var _this2 = this;

    return [markPasteRule({
      find: function find(text) {
        return _find(text).filter(function (link) {
          if (_this2.options.validate) {
            return _this2.options.validate(link.value);
          }

          return true;
        }).filter(function (link) {
          return link.isLink;
        }).map(function (link) {
          return {
            text: link.value,
            index: link.start,
            data: link
          };
        });
      },
      type: this.type,
      getAttributes: function getAttributes(match) {
        var _a;

        return {
          href: (_a = match.data) === null || _a === void 0 ? void 0 : _a.href
        };
      }
    })];
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var plugins = [];

    if (this.options.autolink) {
      plugins.push(autolink({
        type: this.type,
        validate: this.options.validate
      }));
    }

    if (this.options.openOnClick) {
      plugins.push(clickHandler({
        type: this.type
      }));
    }

    if (this.options.linkOnPaste) {
      plugins.push(pasteHandler({
        editor: this.editor,
        type: this.type
      }));
    }

    return plugins;
  }
});
export { Link, Link as default };